import Sidebar from "component/Sidebar"
import OrderTable from "./OrderTable"
import Header from "component/Header"


const OrderManage = () => (
    <>
        <Header root={true} />
        <div className="min-h-screen bg-gray-100 flex flex-col lg:flex-row">
            <Sidebar reloadStore={true} />
            <div className="flex-1 p-4 md:p-8">
                {/* <TopBar /> */}
                <div className="w-full h-full bg-gray-200 border-dashed border-4 border-gray-300">
                    <OrderTable />
                </div>
            </div>
        </div>
    </>
)

export default OrderManage